import apiClient from './apiClient';

export interface QueryParams {
  codeFrom?: string;
  codeTo?: string;
}

export interface PackingMethodRow {
  code: string;
  name: string;
}

export interface QueryResponse {
  data: PackingMethodRow[];
  count: number;
  message?: string;
}

export const pw1315Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw1315/query', params);
    return res.data;
  },
};
